// 系统唯一标识，如： CRO
export const defaultPro = 'CRO'
// 默认语言 'en_US' : 'zh_CN'
export const defaultLang = 'zh_CN'
// 语言本地缓存key
export const defaultLanguage = defaultPro + '_language_123'
// token本地缓存key
export const defaultToken = defaultPro + '_oauth_token'
// 退出okta使用
export const defaultIdToken = defaultPro + '_id_oauth_token'
// 权限本地缓存key
export const defaultPermissions = defaultPro + '_permissions'
// 完整权限
export const defaultPermissionsComplete = defaultPro + '_permissionsComplete'
// userName本地缓存key
export const defaultUserName = defaultPro + '_userName'
// account本地缓存key
export const defaultAccount = defaultPro + '_account'
// roles本地缓存key
export const defaultRoles = defaultPro + '_roles'
// 是否显示语言
export const showLang = false
// true 强制使用默认语言，不可修改
export const langForceFlag = true
